import { Store } from 'src/store/index';

const getClipArtCategory = (store: Store, categoryId: number) => store.addon.clipArtCategories[categoryId];
export default getClipArtCategory;
